import useCommon from '@utils/hooks/common';
import {Statistic, StatisticProps} from 'antd';
import React, {useContext} from 'react';
import {observer} from 'mobx-react';
import styles from './styles';
import {formatCompactNumber} from '@utils/index';
import {TournamentContext} from '@utils/context/index';

interface MultiUnitStatisticProps extends StatisticProps {
  // TODO type
  value: number;
}

const getPrefix = (isTournament: boolean, unit: string): string => {
  if (isTournament) return '';
  if (unit === 'USD') return '$';
  return '';
};

const MultiUnitStatistic = (props: MultiUnitStatisticProps) => {
  const {classes, game, t} = useCommon({
    withStyles: styles,
    observers: ['game', 'user'],
    withTranslation: ['game_room'],
  });

  const {value} = props;
  const {unit} = game;

  const {isTournament} = useContext(TournamentContext);

  const numberFormatter2decimal = (value: number) => {
    if (value >= 10000) {
      return formatCompactNumber(value);
    }

    if (unit === 'USD') {
      if (value % 1 !== 0) {
        return value.toFixed(2);
      }
      return value;
    }
    return value;
  };

  const prefix = getPrefix(isTournament, unit);

  return (
    <Statistic
      className={value ? null : classes.hidden}
      {...props}
      value={game.getDisplayValue(value)}
      prefix={prefix}
      suffix={unit === 'BIG_BLIND' && 'BB'}
      precision={unit === 'USD' ? 2 : 1}
      formatter={numberFormatter2decimal}
    />
  );
};

export default observer(MultiUnitStatistic);
